import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validNameValidator: ValidatorFn = ({ value }: AbstractControl<string>) => {
  return value.length === 0 || (value.length >= 4 && value.length <= 64) ? null : { invalidName: true };
};
